import React from "react";
import { useState } from "react";
import LoginPage from "./LoginPage";
import ResetPassword from "./ResetPassword";

export const Entry = () => {
  const [islogin, setIslogin] = useState("login");

  const isLogin = (value) => {
    setIslogin(value);
  };

  return (
    <div>
      {islogin === "login" && <LoginPage isLogin={isLogin} />}

      {islogin === "reset" && (
        <ResetPassword
          // handleOnChange={handleOnChange}
          // email={email}
          // pass={pass}
          // Submithandler={Submithandler}
          isLogin={isLogin}
        />
      )}
    </div>
  );
};
